import { render, staticRenderFns } from "./ColumnFileActions.vue?vue&type=template&id=406cb494&"
import script from "./ColumnFileActions.vue?vue&type=script&lang=js&"
export * from "./ColumnFileActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports